import { render, staticRenderFns } from "./psRefundList.vue?vue&type=template&id=47974504&scoped=true"
import script from "./psRefundList.vue?vue&type=script&lang=js"
export * from "./psRefundList.vue?vue&type=script&lang=js"
import style0 from "./psRefundList.vue?vue&type=style&index=0&id=47974504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47974504",
  null
  
)

export default component.exports